// extracted by mini-css-extract-plugin
export default {"contributePanelTitle":"TitleContribute-module--contributePanelTitle--55267"};